import { createAsyncThunk } from "@reduxjs/toolkit";
import AuthService from "../store/auth.service";
import authSlice from "../reducer/auth";

export const postAuth = createAsyncThunk("auth/postAuth", async (userData) => {
  try {
    const data = await AuthService.postAuth(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const signUp = createAsyncThunk("auth/signUp", async (userData) => {
  try {
    const { data } = await AuthService.signUp(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const signIn = createAsyncThunk("auth/signIn", async (userData) => {
  try {
    const { data } = await AuthService.signIn(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const signInGuest = createAsyncThunk("auth/signInGuest", async (userData) => {
  try {
    const { data } = await AuthService.signInGuest(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const signInMember = createAsyncThunk("auth/signInMember", async (userData) => {
  try {
    const { data } = await AuthService.signInMember(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const getOtp = createAsyncThunk("auth/getOtp", async (userData) => {
  try {
    const { data } = await AuthService.getOtp(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const sendOtp = createAsyncThunk("auth/sendOtp", async (userData) => {
  try {
    const { data } = await AuthService.sendOtp(userData);
    return data;
  } catch (error) {
    return error.response.data;
  }
});

export const validateOtp = createAsyncThunk(
  "auth/validateOtp",
  async (userData) => {
    try {
      const { data } = await AuthService.validateOtp(userData);
      return data;
    } catch (error) {
      return error.response.data;
    }
  }
);


// export const { setAuth } = authSlice.actions;